import { IonListHeader, IonIcon, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonTextarea } from "@ionic/react";
import {
  albumsOutline,
  arrowDown,
  arrowUp,
  bookmarkOutline,
  chatbubbleOutline,
  eyeOffOutline,
} from "ionicons/icons";
import { PersonView } from "#/features/user/userTypes";
import { ComponentProps } from "react";

import { userHandleSelector } from "#/features/auth/authSelectors";
import { FetchFn } from "#/features/feed/Feed";
import PostCommentFeed, {
  PostCommentItem,
} from "#/features/feed/PostCommentFeed";
import useModZoneActions from "#/features/moderation/useModZoneActions";
import { MaxWidthContainer } from "#/features/shared/AppContent";
import { getHandle, getRemoteHandle, isPost } from "#/helpers/lemmy";
import { useBuildGeneralBrowseLink } from "#/helpers/routes";
import useClient from "#/helpers/useClient";
import { LIMIT } from "#/services/lemmy";
import { useAppSelector } from "#/store";

import Scores from "#/features/user/Scores";
import SocialMedia from "#/features/user/SocialMedia";

import styles from "./CuratorsList.module.css";
import { cx } from "#/helpers/css";
import ProfileAvatar from "#/features/user/ProfileAvatar";


interface ProfileProps
  extends Pick<ComponentProps<typeof PostCommentFeed>, "onPull"> {
  person: PersonView;
}

export default function Profile({ person, onPull }: ProfileProps) {
  const buildGeneralBrowseLink = useBuildGeneralBrowseLink();
  const client = useClient();
  const myHandle = useAppSelector(userHandleSelector);
  const hasSocialMedia = person.person.social_bluesky;

  return (
    <IonItem
      lines="inset"
      routerLink={buildGeneralBrowseLink(
        `/u/${getHandle(person.person)}`
      )}
      detail={false}
    >
      <MaxWidthContainer>
        <IonGrid className='curator-feed'>
          <IonRow className={styles.noWrapRow}>
            <IonCol className={styles.leftWrapper} size="auto">
              <IonItem className={styles.avatarWrapper} lines="none">
                <ProfileAvatar
                  profileImgUrl={person.person.avatar || ''}
                  isSelf={false}
                />
              </IonItem>
            </IonCol>
            <IonCol className={styles.rightWrapper}>
              <IonListHeader className={`${styles.username}${person.person.name?.length > 14 ? ' ' + styles.usernameLong : ''} ion-text-center ion-padding-vertical`}>
                {person.person.name}
              </IonListHeader>
              {/* <Scores
                aggregates={person.counts}
                accountCreated={person.person.published}
                noMargins={true}
              /> */}
            {person.person.bio
              ? (
                <IonItem className={styles.bioContainer} lines="none" style={{marginBottom: 8}}>
                  {person.person.bio}
                </IonItem>
              )
              : null
            }
            </IonCol>
          </IonRow>
          {/* {hasSocialMedia
            ? (
              <IonRow className="ion-justify-content-center">
                <SocialMedia
                  person={person}
                  showIconOnly={true}
                />
              </IonRow>
            )
            : null
          } */}
        </IonGrid>
      </MaxWidthContainer>
    </IonItem>
  );
}

export function getPostCommentItemCreatedDate(item: PostCommentItem): number {
  if (isPost(item)) return Date.parse(item.post.published);
  return Date.parse(item.comment.published);
}
